module.exports = __webpack_public_path__ + "static/media/person4.6d99bc83.svg";